<template>
  <b-row>
    <b-col cols="12">
      <prebid-partners-table />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
// eslint-disable-next-line import/extensions
import PrebidPartnersTable from './PrebidPartnersTable.vue'

export default {
  components: {
    BRow,
    BCol,
    PrebidPartnersTable,
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
